import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
`;

export const Timeline = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const TimelineItem = styled.div<{ $isLast?: boolean }>`
  position: relative;
  display: flex;
  gap: 16px;
  padding-bottom: ${({ $isLast }) => ($isLast ? '0' : '24px')};

  &::before {
    content: '';
    position: absolute;
    left: 6px;
    top: 18px;
    bottom: 0;
    width: 2px;
    background-color: ${({ $isLast }) => ($isLast ? 'transparent' : '#E2E2E2')};
  }
`;

export const TimelineDot = styled.div<{ $status?: string }>`
  width: 14px;
  height: 14px;
  z-index: 1;
  border-radius: 50%;
  background-color: ${({ $status }) => {
    switch ($status) {
      case 'delivered':
        return '#22C55E';
      case 'out_for_delivery':
        return '#3B82F6';
      case 'shipped':
        return '#8B5CF6';
      case 'delayed':
        return '#F59E0B';
      case 'canceled':
        return '#EF4444';
      default:
        return '#6B7280';
    }
  }};
  flex-shrink: 0;
  margin-top: 4px;
`;

export const TimelineContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const EventDescription = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin-bottom: 4px;
`;

export const EventMeta = styled.div`
  font-size: 12px;
  color: #6b7280;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ShipmentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
`;

export const ShipmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ShipmentStatus = styled.span<{ $status?: string }>`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ $status }) => {
    switch ($status) {
      case 'delivered':
        return '#DCFCE7';
      case 'out_for_delivery':
        return '#DBEAFE';
      case 'shipped':
        return '#EDE9FE';
      case 'delayed':
        return '#FEF3C7';
      case 'canceled':
        return '#FEE2E2';
      case 'ordered':
        return '#F3F4F6';
      default:
        return '#F3F4F6';
    }
  }};
  color: ${({ $status }) => {
    switch ($status) {
      case 'delivered':
        return '#166534';
      case 'out_for_delivery':
        return '#1D4ED8';
      case 'shipped':
        return '#6D28D9';
      case 'delayed':
        return '#B45309';
      case 'canceled':
        return '#B91C1C';
      case 'ordered':
        return '#374151';
      default:
        return '#374151';
    }
  }};
`;

export const TrackingNumber = styled.a`
  font-size: 12px;
  color: #3b82f6;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: #1d4ed8;
  }
`;

export const CarrierName = styled.span`
  font-size: 12px;
  color: #6b7280;
`;

export const EstimatedDelivery = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: #6b7280;
  text-align: center;
`;

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`;

export const ShipmentCard = styled.div`
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;
